import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination],
      ...this.defaultOptions,
      ...this.optionsValue
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }

  get defaultOptions() {
    return {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    }
  }
}
